import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/images/ui/loader.svg'


import IModal from '@/js/components/molecules/IModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingModal',
  props: {
    loadingText: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IModal, {
    ref: "modal",
    "with-close-button": false,
    "with-action-button": false,
    "is-loading": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.content)
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: _normalizeClass(_ctx.$style.image),
          "data-chromatic": "ignore"
        }, null, 2),
        _cache[0] || (_cache[0] = _createTextVNode()),
        (_ctx.loadingText)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(_ctx.$style.loadingText)
            }, _toDisplayString(_ctx.loadingText), 3))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 512))
}
}

})